import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  section: css`
    display: flex;
    border-radius: 8px;
    margin-bottom: 12px;
    width: 100%;
  `,
  sectionContent: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  formRow: css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    align-items: flex-start;
  `,
  inputWithDropdown: css`
    display: flex;
    gap: 12px;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    width: 100%;
    & > :first-of-type {
      width: 100%;
    }
  `,
  formField: css`
    display: flex;
    flex-direction: column;
    gap: 6px;
  `,
  twoColumnGrid: css`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  `,

  dropdownButton: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    height: 38px;
    width: auto;
    min-width: 100px;
    background-color: transparent;
    cursor: pointer;
    color: ${theme.colors.neutral.variant[70]};
  `,
  required: ({ theme }) => css`
    color: ${theme.colors.tertiary.red[50]};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
